import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'

const NotificationAward = (props) => {
    if (props.awards[props.notification.award]) {
        return (
            <div>
                <div>
                    You were awarded the <Link to="/about/awards">{props.awards[props.notification.award].title}</Link>
                    <span> {props.awards[props.notification.award].type.toLowerCase()}.</span>
                </div>
                <div><img alt="" src={props.awards[props.notification.award].image.image}/></div>
            </div>
        )
    } else {
        return null
    }
};
const NotificationApplication = (props) => (
    <div>
        Your application for {props.chapters[props.applications[props.notification.application].chapter].game.title} was reviewed by {props.users[props.notification.creator].displayName}.
    </div>
);
const NotificationChapter = (props) => (
    <div>
        You were added to the {props.chapters[props.notification.chapter].game.title} Chapter.
    </div>
);
const NotificationMentionComment = (props) => (
    <div>You were mentioned in a comment</div>
);
const NotificationMentionForum = (props) => (
    <div>You were mentioned in a thread</div>
);
const NotificationPromotion = (props) => (
    <div>
        <div>You were promoted to <Link to="/about/ranks">{props.ranks[props.notification.rank].title}</Link></div>
        <img alt="" src={props.ranks[props.notification.rank].image} />
    </div>
);
const NotificationDemotion = (props) => (
    <div>
        <div>You were demoted to <Link to="/about/ranks">{props.ranks[props.notification.rank].title}</Link></div>
        <img alt="" src={props.ranks[props.notification.rank].image} />
    </div>
);
const NotificationEvent = (props) => (
    <div>A new event is scheduled</div>
);
const NotificationKicked = (props) => (
    <div>You were kicked.</div>
);
const NotificationQuote = (props) => (
    <div>You were quoted.</div>
);
const NotificationScreenshot = (props) => (
    <div>You were tagged in a screenshot.</div>
);

const NotificationDKPItem = (props) => (
    <div>You purchased {props.notification.dkpItem.item.title} for <FontAwesomeIcon className="text-primary" icon={faCoins} fixedWidth /> {parseFloat(props.notification.dkpItem.dkp, 0)} DKP.</div>
);

const NotificationDKPResourceContrib = (props) => (
    <div>You {props.notification.dkpResourcecontrib.amount >= 0 ? "contributed" : "withdrew"} {Math.abs(props.notification.dkpResourcecontrib.amount)} <Link to={"/dkp/resources/" + props.notification.dkpResourcecontrib.resource.slug}>{props.notification.dkpResourcecontrib.resource.title}</Link> {props.notification.dkpResourcecontrib.amount >= 0 ? "to" : "from"} {props.notification.dkpResourcecontrib.resource.sectionDetail.chapter.game.title}.</div>
);


export {
    NotificationAward,
    NotificationApplication,
    NotificationChapter,
    NotificationMentionComment,
    NotificationMentionForum,
    NotificationPromotion,
    NotificationDemotion,
    NotificationEvent,
    NotificationKicked,
    NotificationQuote,
    NotificationScreenshot,
    NotificationDKPItem,
    NotificationDKPResourceContrib
}



// WEBPACK FOOTER //
// ./src/Notifications/NotificationTypes.js